import axios from 'axios';
import {
  axiosRequestInterceptorAuthorizationHeader,
  axiosRequestInterceptorClientHeader,
} from '@/api/axios/interceptors';
import { useUserStore } from '@/store/modules/user/useUserStore';
import { Authentication } from '@/modules/authentication/Authentication';
import router from '@/router';

// console.log(
//   'baseUrl',
//   import.meta.env.DEV ? import.meta.env.VITE_API_BASE_URL : `${location.origin}/api`
// );
const axiosInstance = axios.create({
  baseURL: import.meta.env.DEV ? import.meta.env.VITE_API_BASE_URL : `${location.origin}/api`,
  paramsSerializer: {
    indexes: null,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const locale = 'us';

    axiosRequestInterceptorClientHeader(config);
    axiosRequestInterceptorAuthorizationHeader(config);

    if (locale) {
      config.headers['Accept-Language'] = locale;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const userStore = useUserStore();
    const originalRequest = error.config;
    const authPath = 'user/auth' as const;
    const isAuthRequest = originalRequest.url.includes(authPath);

    if (error.response?.status === 401 && !isAuthRequest && !originalRequest._retry) {
      try {
        await Authentication.refreshTokens();

        originalRequest._retry = true;
        originalRequest.headers.Authorization = `Bearer ${Authentication.accessToken}`;

        return axiosInstance(originalRequest);
      } catch (e) {
        userStore.logoutUser();
        await router.push({ name: 'Home' });
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
